export class SqlEngineStatusFilters {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "_in",
            "baseName": "in",
            "type": "Array<SqlEngineStatus>",
            "format": ""
        },
        {
            "name": "notIn",
            "baseName": "notIn",
            "type": "Array<SqlEngineStatus>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return SqlEngineStatusFilters.attributeTypeMap;
    }
    constructor() {
    }
}
